import {PageRequest} from './page-request';
import {User} from '../../core/auth/user.model';

export class Domain {
  id?: string;
  url?: string;
  description?: string;
  createdOn: string;
  updatedOn: string;
  createdBy: User;
  adsTxtSent: boolean;

  static of(url: string) {
    const dom = new Domain();
    dom.url = url;
    return dom;
  }
}

export class DomainListRequest extends PageRequest {
  url?: any;
  status?: DomainStatus[];
}

export class DomainStatusBox {
  count: number;
  status: string;
}

export enum DomainStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED'
}

export class DomainStatusListing {
  ACTIVE: number;
  ARCHIVED: number;
}

export enum DomainStatusColorMap {
  ACTIVE = 'green',
  ARCHIVED = 'gray'
}

export const DomainStatusLabels = {
  ACTIVE: 'Active',
  ARCHIVED: 'Archived'
};
